
/**
 * Reveal steps component.
 *
 * @example
 *
 * ```
 * <app-step-group [data]="datasource"
 * (eventNewChildren)="eventNewChildren($event)"
 * (eventUpdate)="eventUpdate($event)"
 * (eventDelete)="eventDelete($event)">
 * </app-step-group>
 * ```
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_TREEVIEW_COMPONENTS } from './tree-view.component';
import { NgbCollapseModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
    imports: [
        CommonModule,
        NgbCollapseModule,
        NgbPopoverModule
    ],
    exports: [
        ...APP_TREEVIEW_COMPONENTS,
    ],
    declarations: [
        ...APP_TREEVIEW_COMPONENTS,
    ],
    providers: [],
})
export class Gw3TreeViewModule { }
